<template>
  <div class="flow-chat">
    <div class="wrapper">
      <TitleCom
        titleZh="会议报名流程图"
        titleEn="FLOWCHART OF CONFERENCE REGISTRATION"
      ></TitleCom>
      <div class="d-f-b nav-box">
        <template v-for="item in flowChartList" :key="item.flag">
          <FlowItem :item="item" />
        </template>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, reactive } from 'vue'
import TitleCom from '@/components/TitleCom/index.vue'
import FlowItem from './flow-item.vue'
import { flowChartList } from './source'

export default defineComponent({
  components: {
    TitleCom,
    FlowItem
  },
  setup() {
    return {
      flowChartList: reactive(flowChartList)
    }
  }
})
</script>

<style scoped lang="scss">
.flow-chat {
  width: 100%;
  height: 337px;
  background: #fafafa;
  padding-top: 44px;
  box-sizing: border-box;
  .nav-box {
    margin-top: 40px;
    background-image: url('../../../assets/images/home/flow/line.png');
    background-repeat: no-repeat;
    background-position: 0 47px;
  }
}
</style>
